import { SharingPermission } from "@src/types.generated";

export const PERMISSION_TO_DISPLAY_NAME: Record<SharingPermission, string> = {
  [SharingPermission.Edit]: "Edit",
  [SharingPermission.Comment]: "Comment",
  [SharingPermission.ViewInLibrary]: "View only",
  [SharingPermission.None]: "No access",
};
